// https://gist.github.com/tsdorsey/dff41c99dcc36f07a5eb0f83fa74d487
export const HttpStatus = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102, // RFC 2518, obsoleted by RFC 4918
  OK: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207, // RFC 4918
  AlreadyReported: 208,
  IMUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  TemporaryRedirect: 307,
  PermanentRedirect: 308, // RFC 7238
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  URITooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418, // RFC 2324
  MisdirectedRequest: 421,
  UnprocessableEntity: 422, // RFC 4918
  Locked: 423, // RFC 4918
  FailedDependency: 424, // RFC 4918
  UnorderedCollection: 425, // RFC 4918
  UpgradeRequired: 426, // RFC 2817
  PreconditionRequired: 428, // RFC 6585
  TooManyRequests: 429, // RFC 6585
  RequestHeaderFieldsTooLarge: 431, // RFC 6585
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HTTPVersionNotSupported: 505,
  VariantAlsoNegotiates: 506, // RFC 2295
  InsufficientStorage: 507, // RFC 4918
  LoopDetected: 508,
  BandwidthLimitExceeded: 509,
  NotExtended: 510, // RFC 2774
  NetworkAuthenticationRequired: 511, // RFC 6585
} as const;

export type HttpStatusCode = (typeof HttpStatus)[keyof typeof HttpStatus];
